import { toString, map } from 'lodash';
import loadGeoRasterFromURL from '../load-georaster-from-url';
import adaptURL from '../adapt-url';

import * as layerOps from '../../api/Layers/layer-operations';
import * as styleOps from '../../api/Styles/style-operations';

import customGeoRaster from './customGeoRaster';

/**
 * Builds the GeoTiff layer for the map.
 *
 * @param {object} arg - The object argument.
 * @param {object} arg.layer - The layer object.
 * @param {object} arg.style - The style object.
 * @param {object} [arg.zIndex=10] - The layer object.
 * @returns {object} The leaflet layer to add to the map.
 */

const buildGeoTiffLayer = async ({ layer, style, zIndex = 10 }) => {
  const georaster = await loadGeoRasterFromURL(adaptURL(layerOps.getURL(layer)));
  return customGeoRaster({
    attribution: layerOps.getAttribution(layer),
    georaster,
    opacity: styleOps.getRasterOpacityPercentage(style) / 100,
    pane: toString(zIndex),
    resolution: layerOps.getGeoTiffResolution(layer),
    pixelValuesToColorFn: values => {
      if (values.length < 3) {
        const min = georaster.mins[0];
        const range = georaster.ranges[0];
        const greyValue = Math.floor((255 / range) * (values[0] - min));
        let hexGreyValue = greyValue.toString(16);
        if (hexGreyValue.length < 2) hexGreyValue = `0${hexGreyValue}`;
        return `#${hexGreyValue}${hexGreyValue}${hexGreyValue}`;
      }
      const rgbValues = map(values, value => {
        let hexValue = value.toString(16);
        if (hexValue.length < 2) hexValue = `0${hexValue}`;
        return hexValue;
      });
      return `#${rgbValues.join('')}`;
    }
  });
};

export default buildGeoTiffLayer;
